<i18n>
{
    "en": {},
    "ru": {
        "assortment": "Ассортимент",
        "assortment_very_low": "Очень маленький",
        "assortment_low": "Маленький",
        "assortment_medium": "Нормальный",
        "assortment_high": "Большой",
        "assortment_very_high": "Очень большой",

        "quality_products": "Качество товаров",
        "quality_products_very_low": "Очень низкое",
        "quality_products_low": "Низкое",
        "quality_products_medium": "Нормальное",
        "quality_products_high": "Высокое",
        "quality_products_very_high": "Очень высокое",

        "service": "Облуживание",
        "service_very_low": "Очень плохое",
        "service_low": "Плохое",
        "service_medium": "Нормальное",
        "service_high": "Хорошее",
        "service_very_high": "Очень хорошее",

        "delivery": "Доставка",
        "delivery_very_low": "Очень медленная",
        "delivery_low": "Медленная",
        "delivery_medium": "Нормальная",
        "delivery_high": "Быстрая",
        "delivery_very_high": "Очень быстрая",

        "samples": "Пробники",
        "samples_very_low": "Отсутствуют",
        "samples_low": "Бесполезны",
        "samples_medium": "Присутствуют иногда",
        "samples_high": "Присутствуют всегда",
        "samples_veryHigh": "Подобраны тщательно",

        "refund": "Возврат",
        "refund_very_low": "Очень сложно",
        "refund_low": "Сложно",
        "refund_medium": "Приемлемо",
        "refund_high": "Легко",
        "refund_very_high": "Очень легко",
        "peoples_count": "чел"
    }
}
</i18n>

<template>
    <div class="filter-user-opinion__wrapper">
        <RangeSlider
            v-if="assortmentValue"
            class="filter-user-opinion__progress range-slider_bright"
            :legend="legendAssortment"
            :key="blockKeyPrefix + 'assortment'"
            :title="$t('assortment')"
            :caption-right="getSliderCaption(assortment)"
            :disabled="disableSliders"
            legend-type="header"
            v-model="assortmentValue"
            :values="computeSliderRangeValues(legendAssortment)"
            :pieces="5" />

        <RangeSlider
            v-if="goodsQualityValue"
            class="filter-user-opinion__progress range-slider_bright"
            :legend="legendQuality"
            :key="blockKeyPrefix + 'quality'"
            :title="$t('quality_products')"
            :caption-right="getSliderCaption(goodsQuality)"
            :disabled="disableSliders"
            legend-type="header"
            v-model="goodsQualityValue"
            :values="computeSliderRangeValues(legendQuality)"
            :pieces="5" />

        <RangeSlider
            v-if="serviceValue"
            class="filter-user-opinion__progress range-slider_bright"
            :legend="legendService"
            :key="blockKeyPrefix + 'service'"
            :title="$t('service')"
            :caption-right="getSliderCaption(service)"
            :disabled="disableSliders"
            legend-type="header"
            v-model="serviceValue"
            :values="computeSliderRangeValues(legendService)"
            :pieces="5" />

        <RangeSlider
            v-if="deliveryValue"
            class="filter-user-opinion__progress range-slider_bright"
            :legend="deliveryLegend"
            :key="blockKeyPrefix + 'delivery'"
            :title="$t('delivery')"
            :caption-right="getSliderCaption(delivery)"
            :disabled="disableSliders"
            legend-type="header"
            v-model="deliveryValue"
            :values="computeSliderRangeValues(deliveryLegend)"
            :pieces="5" />

        <RangeSlider
            v-if="samplesValue"
            class="filter-user-opinion__progress range-slider_bright"
            :legend="samplesLegend"
            :key="blockKeyPrefix + 'samples'"
            :title="$t('samples')"
            :caption-right="getSliderCaption(samples)"
            :disabled="disableSliders"
            legend-type="header"
            v-model="samplesValue"
            :values="computeSliderRangeValues(samplesLegend)"
            :pieces="5" />

        <RangeSlider
            v-if="goodsReturnsValue"
            class="filter-user-opinion__progress range-slider_bright"
            :legend="refundLegend"
            :key="blockKeyPrefix + 'goodsReturns'"
            :title="$t('refund')"
            :caption-right="getSliderCaption(goodsReturns)"
            :disabled="disableSliders"
            legend-type="header"
            v-model="goodsReturnsValue"
            :values="computeSliderRangeValues(refundLegend)"
            :pieces="5" />
    </div>
</template>

<script>
import get from 'lodash/get';

import RangeSlider from '@/components/ui/RangeSlider';

export default {
    name: 'BlockUsersOpinion',
    components: {RangeSlider},
    props: {
        assortment: {
            type: Object,
            default: null
        },
        goodsQuality: {
            type: Object,
            default: null
        },
        service: {
            type: Object,
            default: null
        },
        delivery: {
            type: Object,
            default: null
        },
        samples: {
            type: Object,
            default: null
        },
        goodsReturns: {
            type: Object,
            default: null
        },
        disableSliders: {
            type: Boolean,
            default: false
        },
        blockKeyPrefix: {
            type: String,
            default: 'my'
        }
    },
    computed: {
        assortmentValue: {
            get() {
                return this.getPropertyKeyName(this.assortment);
            },
            set(value) {
                this.$emit('assortment', value);
            }
        },
        serviceValue: {
            get() {
                return this.getPropertyKeyName(this.service);
            },
            set(value) {
                this.$emit('service', value);
            }
        },
        goodsQualityValue: {
            get() {
                return this.getPropertyKeyName(this.goodsQuality);
            },
            set(value) {
                this.$emit('goodsQuality', value);
            }
        },
        deliveryValue: {
            get() {
                return this.getPropertyKeyName(this.delivery);
            },
            set(value) {
                this.$emit('delivery', value);
            }
        },
        samplesValue: {
            get() {
                return this.getPropertyKeyName(this.samples);
            },
            set(value) {
                this.$emit('samples', value);
            }
        },
        goodsReturnsValue: {
            get() {
                return this.getPropertyKeyName(this.goodsReturns);
            },
            set(value) {
                this.$emit('goodsReturns', value);
            }
        },
        legendAssortment() {
            return {
                verySmall: this.$t('assortment_very_low'),
                small: this.$t('assortment_low'),
                normal: this.$t('assortment_medium'),
                large: this.$t('assortment_high'),
                veryLarge: this.$t('assortment_very_high')
            };
        },
        legendQuality() {
            return {
                veryLow: this.$t('quality_products_very_low'),
                low: this.$t('quality_products_low'),
                normal: this.$t('quality_products_medium'),
                high: this.$t('quality_products_high'),
                veryHigh: this.$t('quality_products_very_high')
            };
        },
        legendService() {
            return {
                veryBad: this.$t('service_very_low'),
                bad: this.$t('service_low'),
                normal: this.$t('service_medium'),
                good: this.$t('service_high'),
                veryGood: this.$t('service_very_high')
            };
        },
        deliveryLegend() {
            return {
                verySlow: this.$t('delivery_very_low'),
                slow: this.$t('delivery_low'),
                normal: this.$t('delivery_medium'),
                fast: this.$t('delivery_high'),
                veryFast: this.$t('delivery_very_high')
            };
        },
        samplesLegend() {
            return {
                absent: this.$t('samples_very_low'),
                useless: this.$t('samples_low'),
                sometimesPresent: this.$t('samples_medium'),
                alwaysPresent: this.$t('samples_high'),
                carefullySelected: this.$t('samples_veryHigh')
            };
        },
        refundLegend() {
            return {
                veryDifficult: this.$t('refund_very_low'),
                difficult: this.$t('refund_low'),
                acceptable: this.$t('refund_medium'),
                easy: this.$t('refund_high'),
                veryEasy: this.$t('refund_very_high')
            };
        }
    },
    methods: {
        get,
        computeSliderRangeValues(legendProperty) {
            const arrayResult = [];
            const valueNames = Object.keys(legendProperty);
            const step = 100 / (valueNames.length - 1);

            for(let i = 0; i < valueNames.length; i++) {
                arrayResult[valueNames[i]] = step * i;
            }
            // convert to object
            return { ...arrayResult };
        },
        getPropertyKeyName(property) {
            return get(property, 'code', null) || 1;
        },
        getSliderCaption(prop) {
            if(get(prop, 'votes', null)) {
                return this.get(prop, 'votes', null) + ' ' + this.$t('peoples_count')
            }
            else {
                return null;
            }
        }
    }
};
</script>

<style lang="less">
.filter-user-opinion {
    &__wrapper {
        //margin-bottom: rem(120);

        @{desktop} & {
            margin-top: rem(9);
            margin-bottom: rem(16);
        }
    }
}
</style>
